// src/utils/secureFiles.js
import axios from 'axios';

/** Récupère le token depuis localStorage ou cookie (adapte si besoin) */
export function getBearerToken() {
  try {
    // priorité au token SUIVI, sinon fallback générique
    const t1 = localStorage.getItem('bib2z_token_SUIVI');
    if (t1) return t1.replace(/^"(.*)"$/, "$1");
  } catch {}
  // ex: si tu utilises js-cookie: Cookies.get('token')
  return null;
}

export function authHeaders(extra = {}) {
  const token = getBearerToken();
  return {
    Accept: 'application/json',
    ...(extra || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

/** Télécharge un fichier (GET) -> Blob, avec Authorization: Bearer */
export async function fetchBlob(url, extraHeaders = {}) {
  const res = await axios.get(url, {
    responseType: 'blob',
    timeout: 30000,
    headers: {
      'accept': 'application/octet-stream',
      ...authHeaders(extraHeaders),
    },
  });
  const contentType = res.headers['content-type'] || 'application/octet-stream';
  const blob = res.data instanceof Blob ? res.data : new Blob([res.data], { type: contentType });
  return { blob, contentType };
}

/** Force un téléchargement local (via <a download>) depuis un Blob */
export function downloadBlob(blob, filename = 'document') {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Détecte un nom de fichier à partir des headers si possible */
export function filenameFromHeaders(disposition, fallback = 'document') {
  if (!disposition) return fallback;
  const m = /filename\*?=(?:UTF-8''|")?([^";]+)/i.exec(disposition);
  if (!m) return fallback;
  try { return decodeURIComponent(m[1].replace(/"/g, '')); } catch { return m[1]; }
}

/** Déduit un content-type depuis une extension */
export function guessContentType(name = '') {
  const ext = (name.split('.').pop() || '').toLowerCase();
  const map = {
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif', svg: 'image/svg+xml',
    webp: 'image/webp',
    mp4: 'video/mp4', webm: 'video/webm', ogg: 'video/ogg',
    mp3: 'audio/mpeg', wav: 'audio/wav',
    txt: 'text/plain', csv: 'text/csv', html: 'text/html', json: 'application/json',
  };
  return map[ext] || 'application/octet-stream';
}
